"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GIF = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GIF_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 16,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.182 11.844c-.719 0-1.315-.14-1.79-.42-.467-.285-.816-.7-1.047-1.245C.115 9.628 0 8.958 0 8.17c0-.865.126-1.594.377-2.187.258-.6.628-1.054 1.11-1.361.488-.314 1.067-.471 1.737-.471.39 0 .733.045 1.026.136.3.09.565.202.795.335l-.47 1.371a2.25 2.25 0 0 0-.608-.261 2.052 2.052 0 0 0-.586-.084c-.384 0-.705.09-.963.272-.251.181-.44.457-.565.827-.119.363-.178.816-.178 1.36 0 .433.049.817.146 1.152.098.335.241.6.43.796.195.188.443.282.743.282a1.927 1.927 0 0 0 .544-.084V8.83h-.69V7.384h2.218v4.02c-.314.16-.628.272-.942.335a4.33 4.33 0 0 1-.942.105ZM6 11.739v-1.235l1.351-.157v-4.69L6.001 5.5V4.265h4.302V5.5l-1.309.157v4.69l1.309.157v1.235H6ZM11.447 11.739V4.265H16v1.497h-2.879v1.706h2.711v1.497h-2.71v2.774h-1.675Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GIF_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GIF;
exports["default"] = _default;